export default __webpack_public_path__ + "static/media/story-SLIDE_4.d00c818d.jpg";